import React from 'react'
import ConnectorCard, { CARD_STATE } from '../../../SharedComponents/ConnectorCard/ConnectorCard'
import Style from '../marketplace.module.css'

const cardState = (system, builder) => {
    if (!builder.first) return CARD_STATE.IDLE
    if (system.id === builder.first.id || (builder.second && system.id === builder.second.id)) return CARD_STATE.SELECTED
    if (builder.isLoadingIntegrations) return CARD_STATE.IDLE
    return builder.isCompatible(system) ? CARD_STATE.COMPATIBLE : CARD_STATE.MUTED
}

const SystemGrid = ({ title, description, systems, builder, ownedShortNames, showDescriptions }) => (
    <section className={Style.group} aria-label={title}>
        {title ? (
            <header className={Style.groupHeader}>
                <h3 className={Style.groupTitle}>{title} <span className={Style.groupCount}>{systems.length}</span></h3>
                {description ? <p className={Style.groupDescription}>{description}</p> : null}
            </header>
        ) : null}
        <div className={Style.grid}>
            {systems.map((system) => (
                <ConnectorCard
                    key={system.id}
                    system={system}
                    state={cardState(system, builder)}
                    isInAccount={ownedShortNames.has(system.shortName)}
                    compatibleWith={builder.first ? builder.first.shortName : null}
                    showDescription={Boolean(showDescriptions)}
                    onSelect={builder.select}
                />
            ))}
        </div>
    </section>
)

export default SystemGrid
